"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var languages_1 = require("../../utils/helpers/languages");
require("./styles.scss");
exports.default = (function (props) {
    var selectedLanguage = languages_1.languageData.find(function (l) { return l.code.toLowerCase() === props.languageCode.toLowerCase(); }) || languages_1.languageData[0];
    return (React.createElement(sok_ui_1.Dropdown2, { className: "sok-language-selector", alignment: props.isMobile ? 'center' : 'right' },
        React.createElement("img", { src: (0, languages_1.getLanguageFlag)(selectedLanguage.code), className: 'language-icon', title: selectedLanguage.name, alt: selectedLanguage.code }),
        React.createElement(sok_ui_1.Dropdown2Menu, { className: "sok-language-selector-menu" }, languages_1.languageData.map(function (lang) { return (React.createElement("div", { key: lang.code, onClick: function () { return props.updateUserLanguage(lang.code); } },
            React.createElement("div", null,
                React.createElement("span", null,
                    React.createElement("img", { src: (0, languages_1.getLanguageFlag)(lang.code), alt: lang.code, style: { width: 24, height: 18 } })),
                React.createElement("span", null, lang.name)))); }))));
});
